<template>
<el-row>
   <headertop></headertop>
   <div class="all" ref="father_file">
     <el-breadcrumb separator="/">
       <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
       <el-breadcrumb-item :to="{ path: '/file' }">文档资源</el-breadcrumb-item>
       <el-breadcrumb-item>{{file.info.name}}</el-breadcrumb-item>
     </el-breadcrumb>
    <div class="con_div">
      <div class="pdf_div" >
        <div class="whole"  v-if="file.info.type=='pdf'"  style="overflow-y: auto;">
          <div style="margin-bottom: 15px; " class="con">
            <el-button type="primary" size="small" @click="scaleD">
               放大
             </el-button>
             <el-button type="primary" size="small" @click="scaleX">
               缩小
            </el-button>
            <el-button type="primary" size="small" @click.stop="pdf_previousPage">
               上一页
             </el-button>
             <el-button type="primary" size="small" @click.stop="pdf_nextPage">
             下一页
            </el-button>
            <el-row style="margin-left: 10px;">
              <span >当前第{{file.pdfPage}}页 / 共{{file.pageCount}}页</span>
            </el-row>
          </div>
          <div :style="{height:height}" class="over con ">
           <pdf
              ref="wrapper"
             :src="file.url"
             :page="file.pdfPage"
             @num-pages="file.pageCount = $event"
             @page-loaded="file.pdfPage = $event"
          ></pdf>
          </div>
        </div>
        <div class="whole" v-if="file.info.type=='html'" >
           <iframe :src="file.url" frameborder="0" :height="height" style="width:100%;"></iframe>
        </div>
      </div>
    </div>
    <div class="player-div" ref="player_div">
      <button @click="support('support')" style="cursor: pointer;color: white;" v-if="file.info.support=='1'">已赞</button>
      <button @click="support('support')" style="cursor: pointer;color: white;" v-else>点赞</button>
      <button @click="support('collect')" style="cursor: pointer;color: white;" v-if="file.info.collect=='1'">已收藏</button>
      <button @click="support('collect')" style="cursor: pointer;color: white;" v-else>收藏</button>
      <button @click="file_video()" style="cursor: pointer;color: white;" v-if=" file.info.video != '' &&  file.info.video != '0'">讲解视频</button>
      <button v-if="file.info.file_link !='0'" @click="chaolianjie(file.info.file_link)" style="cursor: pointer;color: white;">附加文档</button>
    </div>
   </div>
   <footerbom></footerbom>
</el-row>
</template>


<script>
    import Header from '../../../components/index/public/visitor_NavHeader.vue';
  import Footer from '../../../components/index/public/NavFooter.vue';
  import pdf from 'vue-pdf'
  export default {
    name: 'App',
    data() {
      return {
        play:{
          info:{},
          status:false,
        },
        trigger:false,
        player: null,
        file:{
          scale:100,
          num:this.$route.query.num,
          info:{},
          pdfPage : 1,
          pageCount: 0,
        },
        height:'',
      }
    },
    components: {
      headertop: Header,
      footerbom: Footer,
      pdf
    },
    mounted:function(){
     this.get_info()
     this.change_height()
    },
    methods: {
      scaleD() {
        this.file.scale += 5;
        this.$refs.wrapper.$el.style.width = parseInt(this.file.scale) + "%";
      },
      //缩小
      scaleX() {
        this.file.scale += -5;
        this.$refs.wrapper.$el.style.width = parseInt(this.file.scale) + "%";
      },
      file_video(){
        window.open('/file_video?num='+this.file.num,'_blank')
      },
      pdf_previousPage(){
        var p = this.file.pdfPage
        p = p>1?p-1:this.file.pageCount
        this.file.pdfPage = p
      },
      pdf_nextPage(){
        var p = this.file.pdfPage
        p = p<this.file.pageCount?p+1:1
        this.file.pdfPage = p
      },
      support(opration){
        let _this=this
        _this.axios.post('/v2/user_resource/resource_support',{data:{resource_type:'file',type:'1',num:_this.file.num,opration:opration}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.$message.success(res.data.msg)
              if(opration=='support'){
                _this.file.info.support=res.data.data
              }else{
                _this.file.info.collect=res.data.data
              }
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },

      change_height(){
        let _this=this
        let fatherH = _this.$refs.father_file.offsetHeight
        let footerH = _this.$refs.player_div.offsetHeight
        _this.height=fatherH - footerH + 'px'
      },

      get_info() {
        let _this=this
        _this.axios.get('/v2/user_resource/get_file_info',{params:{file:_this.file.num, type:'study'}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.file.info=res.data.data
              if(res.data.data.type=='pdf'){
                _this.file.url=pdf.createLoadingTask('/v2/user_resource/file_watch?key='+localStorage.authorization)
              }else{
                _this.file.url='/v2/user_resource/file_watch?key='+localStorage.authorization
              }
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },

      file_watch(re){
        this.file.url = pdf.createLoadingTask(re)
      },

      handle(row) { },
    //滚动到顶部
    top(){
      if (this.trigger) return;
        var curTop = document.documentElement.scrollTop || document.body.scrollTop
        var each = curTop / 2000
        var timer = setInterval(function () {
            this.trigger = true
            curTop -= each
            each += 5
            if (curTop <= 0) {
                clearInterval(timer)
                trigger = false
            }
            window.scrollTo(0, curTop)
        }, 10)
    },
    //添加笔记
    onSubmit(){},
    //超链接点击跳转
    chaolianjie(url){
      window.open(url,"_blank");
    }


  }}
</script>

<style scoped>
  .con{
      display: flex;
      justify-content: center;
  }
  .over{
    overflow: auto;
  }
  .resize {
      cursor: col-resize;
      float: left;
      position: relative;
      background-color: #d6d6d6;
      border-radius: 5px;
      margin-top: 25rem;
      width: 10px;
      height: 50px;
      background-size: cover;
      background-position: center;
      /*z-index: 99999;*/
      font-size: 32px;
      color: white;
  }
  /*拖拽区鼠标悬停样式*/
  .resize:hover {
      color: #444444;
  }

.all{
  min-height: calc(100vh - 330px);
  width: 62%;
  padding: 20px;
  margin: 0 15%;
  z-index: 100;
  background-color: white;
  overflow: hidden;
}
.video_div{
  width: 100%;
  height: 100%;
  margin: 1% 0px;
  overflow: hidden;
}
.video_left{
  background-color: #000000;
  width: calc(32% - 10px); /*左侧初始化宽度*/
  height: 100%;
  float: left;
}
.video_right{
  background-color: #000066;
  float: left;
  width: 68%;   /*右侧初始化宽度*/
  height: 100%;
}
.con_div{
  margin-top: 1.5rem;
}
.player-div{
   width: 100%;
    height: 40px;
    margin-top: 1.5rem;
   background-color: rgb(80, 79, 77);
}
  .player-div button{
      height: 100%;
      background-color: rgb(80, 79, 77);
      border: none;
      margin-left: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/view/visitor/File/FileQCregister.vue